import React from 'react';
import { Table, Tag } from 'antd';

export interface MarketShiftItem {
  id?: number;
  winner_brand: string;
  loser_brand: string;
  share_gained: number;
  keywords_count: number;
  confidence_score: number;
  from_period_week?: string;
  to_period_week?: string;
}

export interface BrandMarketShiftProps {
  data: MarketShiftItem[];
}

export const BrandMarketShift: React.FC<BrandMarketShiftProps> = ({ data }) => {
  return (
    <Table
      size="small"
      rowKey={(r) => String(r.id ?? `${r.winner_brand}-${r.loser_brand}-${r.from_period_week}-${r.to_period_week}`)}
      dataSource={data}
      pagination={{ pageSize: 10 }}
      columns={[
        { title: '起始周期', dataIndex: 'from_period_week', width: 110 },
        { title: '结束周期', dataIndex: 'to_period_week', width: 110 },
        { title: '赢家品牌', dataIndex: 'winner_brand' },
        { title: '输家品牌', dataIndex: 'loser_brand' },
        { title: '抢占份额(%)', dataIndex: 'share_gained', sorter: (a, b) => a.share_gained - b.share_gained, width: 120 },
        { title: '关键词数', dataIndex: 'keywords_count', sorter: (a, b) => a.keywords_count - b.keywords_count, width: 110 },
        {
          title: '可信度',
          dataIndex: 'confidence_score',
          sorter: (a, b) => a.confidence_score - b.confidence_score,
          render: (v: number) => (
            <Tag color={v >= 0.7 ? 'green' : v >= 0.4 ? 'gold' : 'red'}>{v.toFixed(2)}</Tag>
          ),
          width: 110,
        },
      ]}
    />
  );
};

export default BrandMarketShift;



